// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    
export class LaborHoursDistribution {
  levelID: string;
  levelDescription: string;
  description: string;
  pmHours: number;
  engHours: number;
  grapHours: number;
  progHours: number;
  specHours: number;
  ddsHours: number;
  mechHours: number;
  elecHours: number;
  typicalOfCount: string;
  typicalOfCountInArea: string;
}
